import * as prodPrograms from '../assets/programs.prod.json';

export const environment = {
  production: true,
  programs: (prodPrograms as any).default,
  loginApiUrl: 'https://myhomepage.waldenu.edu/Walden/uvm_login?',
  adminApiUrl: 'https://api.laureate.net',
  ocpKey: '67fcffd70f0e4c2d909ba6914ae2150f'
};
